import { useEffect, useState } from 'react'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

// local imports
import './RemotePlanSideBar.scss'
import { ISideBarModel, ViewSideBar } from 'types/CalendarType'
import AsyncImage from 'components/ui/AsyncImage'
import Button1 from 'components/ui/Button1'
import warningImage from 'assets/images/warning-image.svg'

const RemotePlanSideBar = (props: { model: ISideBarModel; onClickDeleteRemotePlan: (arg0: any) => any }) => {
  /**
   * VIEW
   * CREATE
   * CANCEL
   */
  const { t } = useTranslation()
  const [height, setHeight] = useState(window.innerHeight)
  const [displayDialog, setDisplayDialog] = useState(false)

  console.log('=== RemotePlanSideBar RENDERED ===')
  console.log('Props:', props)
  console.log('Props.model:', props.model)
  console.log('Props.model.event:', props.model?.event)
  console.log('Event description:', props.model?.event?.description)
  console.log('Event remoteOfficeType:', props.model?.event?.remoteOfficeType)

  const updateDimensions = () => {
    setHeight(window.innerHeight)
  }

  useEffect(() => {
    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const formatDate = (date: Date) => {
    if (date === null || date === undefined) return ''
    let res = moment(date)
    return res.format('DD.MM.YYYY')
  }

  const deleteHomePlan = () => {
    props?.onClickDeleteRemotePlan(props?.model)
  }

  const onHide = () => {
    setDisplayDialog(false)
  }

  const renderFooter = () => {
    return (
      <div className="d-flex flex-row of-confirm-footer">
        <Button label={t('buttons.no')} onClick={onHide} className="p-button-outlined w-100" />
        <Button
          label={t('buttons.yes')}
          onClick={() => {
            deleteHomePlan()
          }}
          className="w-100 of-button-primary"
          disabled={false}
        />
      </div>
    )
  }

  const confirmDialogUI = () => {
    return (
      <Dialog
        header=""
        visible={displayDialog}
        position={'center'}
        modal
        style={{ width: '400px' }}
        footer={renderFooter()}
        onHide={onHide}
        draggable={false}
        resizable={false}>
        <div className="d-flex flex-column of-newplan-confirm-dialog">
          <div className="of-confirm-image">
            <img src={warningImage} alt="" />
          </div>
          <div className="">
            <p className="of-confirm-info mt-2">{t('overlaypanel-texts.cancel-process')}</p>
          </div>
          <div className="of-confirm-detail">
            <p>{t('overlaypanel-texts.cancel-from-remote')}</p>
            <p>
              <strong>{t('input-texts.date')}:</strong> {formatDate(props?.model?.day?.date)}
            </p>
          </div>
        </div>
      </Dialog>
    )
  }

  const getCalculatedHeight = () => {
    if (height) {
      let value = height - 90
      if (height < 400) return 600
      return value
    }
  }

  return (
    <>
      <div className="of-remote-sidebar-container" style={{ height: getCalculatedHeight() }}>
        <div className="text-center">
          <p className="of-sidebar-header">{t('dashboard.remote-office-notification')}</p>
          <p className="of-sidebar-description">{t('squads-event.remote-text')}</p>
        </div>
        <p className="mt-2 of-plandate-wheretowork">{t('squads-event.remote-info')}</p>
        <div className="of-sidebar-personnel d-flex flex-row mb-3">
          <div className="d-flex align-items-center">
            <AsyncImage className={'of-remote-photo'} src={props?.model?.user?._photoUrl} alt="" />
          </div>
          <div className="p-2">
            <div className={'of-name'}>{props?.model?.user?.fullName}</div>
            <div className={'of-title'}>{props?.model?.user?.positionName}</div>
          </div>
        </div>

        <div className="of-plandate mt-4">
          <p>
            <i className="pi pi-calendar"></i>
            <span>{t('input-texts.date')}: </span>
            {formatDate(props?.model?.event?.reservationDate)}
          </p>
        </div>
        <div className="of-plandate mt-2">
          <p>
            <i className="pi pi-home"></i>
            <span>{t('most-used-words.location')}: </span>
            {props?.model?.event?.description}
          </p>
        </div>
        {props?.model?.view === ViewSideBar.CANCEL ? (
          <div className="of-remote-bottom-buttons">
            <div className="w-100">
              <Button1
                class={'button-blue'}
                label={t('buttons.cancel-notification')}
                onClick={(e) => setDisplayDialog(true)}
                disabled={false}
              />
            </div>
          </div>
        ) : null}

        {confirmDialogUI()}
      </div>
    </>
  )
}

export default RemotePlanSideBar
